import { Injectable } from '@angular/core';

@Injectable()
export class LogService {

    logs_enable = !window['_env'].production;

    constructor() { }

    printLog(message, ...args) {
        if(this.logs_enable) {
            console.log(message, args);
        }
    }

    printWarning(message, ...args) {
        if(this.logs_enable) {
            console.warn(message, args);
        }
    }

    printError(message, ...args) {
        if(this.logs_enable) {
            console.error(message, args);
        }
    }

}
